import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.page`

export default defineMessages({
  settingsTitle: {
    id: `${scope}.settingsTitle`,
    defaultMessage: 'Settings',
  },
  closingMonthsPageTitle: {
    id: `${scope}.closingMonthsPageTitle`,
    defaultMessage: 'Closing months',
  },
  moduleLoading: {
    id: `${scope}.moduleLoading`,
    defaultMessage: 'Module loading...',
  },
  billApprovalsPageTitle: {
    id: `${scope}.billApprovalsPageTitle`,
    defaultMessage: 'Bill approval',
  },
  unbilledItemsPageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Unbilled items',
  },
  unbilledItemsTabName: {
    id: `${scope}.unbilledItemsTabName`,
    defaultMessage: 'Procurify | Unbilled items',
  },
  unbilledExpenseItemsPageTitle: {
    id: `${scope}.unbilledExpenseItemsPageTitle`,
    defaultMessage: 'Unbilled expense items',
  },
  unbilledExpenseItemsTabName: {
    id: `${scope}.unbilledExpenseItemsTabName`,
    defaultMessage: 'Procurify | Unbilled expense items',
  },
  creditCardReconciliationPageTitle: {
    id: `${scope}.creditCardReconciliationPageTitle`,
    defaultMessage: 'Credit card reconciliation',
  },
  reconciliationMatchPageTitle: {
    id: `${scope}.reconciliationMatchPageTitle`,
    defaultMessage: 'Reconciling',
  },
  reconciliationBreadcrumb: {
    id: `${scope}.reconciliationBreadcrumb`,
    defaultMessage: 'Reconciliation',
  },
  createCreditCardBillPageTitle: {
    id: `${scope}.createCreditCardBillPageTitle`,
    defaultMessage: 'New credit card bill',
  },
  expenseRecordsPageTitle: {
    id: `${scope}.expenseRecordsPageTitle`,
    defaultMessage: 'Expenses',
  },
  creditCardBillBreadcrumb: {
    id: `${scope}.creditCardBillBreadcrumb`,
    defaultMessage: 'Credit card bill',
  },
  overallSpendReportPageTitle: {
    id: `${scope}.overallSpendReportPageTitle`,
    defaultMessage: 'Overall spend',
  },
  manageBankCreditCardAccountsPageTitle: {
    id: `${scope}.manageBankCreditCardAccountsPageTitle`,
    defaultMessage: 'Manage bank & credit card accounts',
  },
  discoverAccountsPayablePageTitle: {
    id: `${scope}.discoverAccountsPayablePageTitle`,
    defaultMessage: 'Discover Accounts Payable',
  },
})
